<template>
  <div class="container" v-if="$root.homepageShow">
    <!-- 第一行 -->
    <div class="first_row">
      <!-- 第一格 -->
      <div class="first_grid">
        <div class="shop_general box_shadow white">
          <div class="box_title">商铺概览</div>
          <div class="box_content">
            <div class="item">
              <div class="icon bg1 el-icon-coin"></div>
              <div class="text">
                <div class="title">商户数量</div>
                <div class="num">{{ lesseeCount }}</div>
              </div>
            </div>
            <div class="item">
              <div class="icon bg2 iconfont icon-dianbiao"></div>
              <div class="text">
                <div class="title">电表数量</div>
                <div class="num">{{ meterCount }}</div>
              </div>
            </div>
            <div class="item">
              <div class="icon bg3 iconfont icon-shuibiao"></div>
              <div class="text">
                <div class="title">水表数量</div>
                <div class="num">{{ waterCount }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="status">
          <div class="electric_meter box_shadow white">
            <div class="pieChart" id="electricMeter"></div>
          </div>
          <div class="water_meter box_shadow white">
            <div class="pieChart" id="waterMeter"></div>
          </div>
        </div>
      </div>
      <!-- 第二格 -->
      <div class="second_grid box_shadow white">
        <div class="box_title">用量情况</div>
        <div class="btns">
          <el-select
            v-model="sumpDateSelect"
            placeholder="请选择"
            size="small"
            filterable
            @change="getSelectYearlyMonthlyData"
          >
            <el-option
              v-for="item in sumpDateSelectOptions"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </div>
        <div class="box_content">
          <div class="left">
            <div class="dashChart" id="electric_meter_dash"></div>
            <div class="compare_data">
              <p style="display:flex;margin-right:25px;">
                <span class="compare_tit">同比：</span>
                <!-- <span class="numStyle">0.0</span> -->
                <span class="numStyle">{{ compareData.meterYearlyValue }}</span>
                <span
                  class="icon-shang iconfont rateSpanRed"
                  v-if="compareData.meterYearlyType == 1"
                >
                  {{ compareData.meterYearlyPercent }}
                </span>
                <span class="icon-xia iconfont rateSpanGreen" v-else
                  >{{ compareData.meterYearlyPercent }}
                </span>
              </p>
              <p style="display:flex;margin-right:25px;">
                <span class="compare_tit">环比：</span>
                <span class="numStyle">{{
                  compareData.meterMonthlyValue
                }}</span>
                <span
                  class="icon-shang iconfont rateSpanRed"
                  v-if="compareData.meterMonthlyType == 1"
                  >{{ compareData.meterMonthlyPercent }}
                </span>
                <span class="icon-xia iconfont rateSpanGreen" v-else
                  >{{ compareData.meterMonthlyPercent }}
                </span>
              </p>
            </div>
          </div>

          <div class="right">
            <div class="dashChart" id="water_meter_dash"></div>
            <div class="compare_data">
              <p style="display:flex;">
                <span class="compare_tit" style="margin-left: 20px;">同比：</span>
                <span class="numStyle">{{ compareData.waterYearlyValue }}</span>
                <span
                  class="icon-shang iconfont rateSpanRed"
                  v-if="compareData.waterYearlyType == 1"
                  >{{ compareData.waterYearlyPercent }}
                </span>
                <span class="icon-xia iconfont rateSpanGreen" v-else
                  >{{ compareData.waterYearlyPercent }}
                </span>
              </p>
              <p style="display:flex;">
                <span class="compare_tit" style="margin-left: 20px;">环比：</span>
                <span class="numStyle">{{
                  compareData.waterMonthlyValue
                }}</span>
                <span
                  class="icon-shang iconfont rateSpanRed"
                  v-if="compareData.waterMonthlyType == 1"
                  >{{ compareData.waterMonthlyPercent }}
                </span>
                <span class="icon-xia iconfont rateSpanGreen" v-else
                  >{{ compareData.waterMonthlyPercent }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- 第三格 -->
      <div class="third_grid box_shadow white">
        <el-tabs v-model="warnActiveName">
          <el-tab-pane label="欠费异常" name="abnormal">
            <!-- <dv-scroll-board
              v-if="warnActiveName == 'abnormal'"
              :config="errorConfig"
            /> -->
            <div>
              <ul class="titleRow">
                <li><span>商户</span></li>
                <li><span>账户类型</span></li>
                <li><span>报警类型</span></li>
                <li><span>报警余额(元)</span></li>
              </ul>
              <vue-seamless-scroll
                :data="arrearsAlarmData"
                :class-option="seamlessOptions"
                class="seamless-warp"
              >
                <ul class="item">
                  <li v-for="(item, index) in arrearsAlarmData" :key="index">
                    <span class="title" v-text="item.lesseeName"></span>
                    <span class="date" v-text="item.accountType"></span>
                    <span class="date" v-text="item.alarmType"></span>
                    <span class="date" v-text="item.alarmBalance"></span>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </el-tab-pane>
          <el-tab-pane label="参数异常" name="param">
            <!-- <dv-scroll-board
              v-if="warnActiveName == 'param'"
              :config="errorConfig1"
            /> -->
            <div>
              <ul class="titleRow">
                <li><span>商户</span></li>
                <li><span>报警类型</span></li>
                <li><span>表号</span></li>
                <li><span>表类型</span></li>
              </ul>
              <vue-seamless-scroll
                :data="dataAlarmData"
                :class-option="seamlessOptions"
                class="seamless-warp"
              >
                <ul class="item">
                  <li v-for="(item, index) in dataAlarmData" :key="index">
                    <span class="title" v-text="item.lesseeName"></span>
                    <span class="date" v-text="item.alarmType"></span>
                    <span class="date" v-text="item.meterAddr"></span>
                    <span class="date" v-text="item.meterType"></span>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="second_row">
      <div class="first_grid box_shadow white">
        <el-tabs v-model="activeName">
          <el-tab-pane label="电能耗曲线" name="electric">
            <div class="header">
              <div>
                <span
                  :style="{
                    border: activeConsum1
                      ? '1px solid #60d5e7'
                      : '1px solid #ddd',
                  }"
                  @click="getSelectUsageLineChartData('当日')"
                  >当日</span
                >
                <span
                  :style="{
                    border: activeConsum2
                      ? '1px solid #60d5e7'
                      : '1px solid #ddd',
                  }"
                  @click="getSelectUsageLineChartData('昨日')"
                  >昨日</span
                >
                <span
                  :style="{
                    border: activeConsum3
                      ? '1px solid #60d5e7'
                      : '1px solid #ddd',
                  }"
                  @click="getSelectUsageLineChartData('近三十天')"
                  >近30天</span
                >
              </div>
            </div>
            <div class="content">
              <div class="lineChart" id="electric_lineChart"></div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="水能耗曲线" name="water">
            <div class="header">
              <div>
                <span style="border: 1px solid #60d5e7">近30天</span>
              </div>
            </div>
            <div class="content">
              <div class="lineChart" id="water_lineChart"></div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="second_grid box_shadow white">
        <div class="header">
          <span class="tit">最近七天交费信息</span>
        </div>
        <div class="content">
          <div class="lineChart" id="pay_barChart"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import {
  selectHomePageOverview,
  selectLatestTwelveMonth,
  selectYearlyMonthlyData,
  selectUsageLineChartData,
  selectLatestSevenDaysPayInfo,
  selectAlarmData,
} from '../api/homePage';
import dictionaryConstant from '../constant/dictionaryConstant';
import { generatorUUID } from '../untils/func';
import websocketConstant from '../constant/websocketConstant';
export default {
  data() {
    return {
      websocketPath: '',
      websocket: '',

      lesseeCount: '',
      meterCount: '',
      waterCount: '',
      meterStatePieChartData: [],
      waterStatePieChartData: [],
      compareData: {},
      energyConsumptionData: {},
      sevenDaysPayData: {},

      arrearsAlarmData: [],
      dataAlarmData: [],

      sumpDateSelectOptions: [],
      sumpDateSelect: '',
      activeName: 'electric',
      warnActiveName: 'abnormal',
      electricMeterChart: '', //电表状态
      waterMeterChart: '', //水表状态
      electricMeterDashChart: '', //电表仪表盘图表
      waterMeterDashChart: '', //水表仪表盘图表
      electricMeterDashChart1: '', //电表仪表盘图表
      waterMeterDashChart1: '', //水表仪表盘图表
      electricLineChart: '',
      waterLineChart: '',
      payBarChart: '',
      activeConsum1: false,
      activeConsum2: false,
      activeConsum3: true,
      timeInterval: '',
    };
  },
  created() {},
  mounted() {
    this.init();
    // 重置图表
    window.addEventListener('resize', this.resizeChart);

    this.timeInterval = setInterval(async () => {
      await this.getSelectHomePageOverview();
      await this.getSelectAlarmData();
      await this.getSelectUsageLineChartData();
    }, 1000 * 60 * 60);
	window.myTimer.push(this.timeInterval);
    this.initWebsocket();
  },
  computed: {
    seamlessOptions() {
      return {
        singleHeight: 39,
        step: 2,
      };
    },
  },
  watch: {
    $route(to) {
      if (to.path == '/mainWindow/homePage') {
        this.resizeChart();
      }
    },
    activeName(newVal) {
      if (newVal == 'electric') {
        this.$nextTick(() => {
          this.createElectricLineChart();
          this.getSelectUsageLineChartData();
        });
      } else if (newVal == 'water') {
        this.$nextTick(() => {
          this.createWaterLineChart();
          this.getSelectUsageLineChartData();
        });
      }
    },
  },
  methods: {
    initWebsocket() {
      const uuid = generatorUUID();
      this.websocketPath = this.$root.platformUrl + '/websocket/' + uuid;
      console.log(this.websocketPath);
      if (typeof WebSocket === 'undefined') {
        alert('您的浏览器不支持socket');
      } else {
        // 实例化socket
        this.websocket = new WebSocket(this.websocketPath);
        // 监听socket连接
        this.websocket.onopen = this.openWebsocket;
        // 监听socket错误信息
        this.websocket.onerror = this.errorWebsocket;
        // 监听socket消息
        this.websocket.onmessage = this.getMessageWebsocket;
      }
    },

    openWebsocket() {
      console.log('socket 打开');
    },
    errorWebsocket() {
      console.log('出现错误');
    },
    getMessageWebsocket(msg) {
      if (
        msg != undefined &&
        msg != null &&
        msg.data != null &&
        msg.data != '' &&
        msg.data == websocketConstant.NOTIFY_HOME_PAGE_ALARM_REFRESH
      ) {
        // this.msgSuccess(msg.data);
        this.getSelectAlarmData();
      }
    },
    sendWebsocket() {
      this.websocket.send('123');
    },
    closeWebsocket() {
      console.log('socket已经关闭');
    },

    async init() {
      await this.getSelectHomePageOverview();
      await this.getSelectLatestTwelveMonth();
      await this.getSelectUsageLineChartData();
      await this.getSelectLatestSevenDaysPayInfo();
      await this.getSelectAlarmData();
    },
    // 获取第一格数据并绘制饼图
    async getSelectHomePageOverview() {
      const res = await selectHomePageOverview().then();
      this.lesseeCount = res.data.lesseeCount;
      this.meterCount = res.data.meterCount;
      this.waterCount = res.data.waterCount;
      this.meterStatePieChartData = res.data.meterStatePieChartData;
      this.waterStatePieChartData = res.data.waterStatePieChartData;

      this.createElectricMeterChart();
      this.createWaterMeterChart();
    },
    // 同比环比下拉列表
    async getSelectLatestTwelveMonth() {
      const res = await selectLatestTwelveMonth().then();
      this.sumpDateSelectOptions = res.data;
      this.sumpDateSelect = this.sumpDateSelectOptions[0].key;
      await this.getSelectYearlyMonthlyData();
    },
    // 获取同比环比图表数据
    async getSelectYearlyMonthlyData(key) {
      const res = await selectYearlyMonthlyData({
        date: key || this.sumpDateSelect,
      }).then();
      this.compareData = res.data;

      this.createElectricMeterDashChart();
      this.createWaterMeterDashChart();
    },
    // 获取能耗曲线数据
    async getSelectUsageLineChartData(date) {
      if (date) {
        if (date == '当日') {
          this.activeConsum1 = true;
          this.activeConsum2 = false;
          this.activeConsum3 = false;
        } else if (date == '昨日') {
          this.activeConsum1 = false;
          this.activeConsum2 = true;
          this.activeConsum3 = false;
        } else if (date == '近三十天') {
          this.activeConsum1 = false;
          this.activeConsum2 = false;
          this.activeConsum3 = true;
        }
      } else {
        this.activeConsum1 = false;
        this.activeConsum2 = false;
        this.activeConsum3 = true;
      }
      var sensorType;
      if (this.activeName == 'electric') {
        sensorType = dictionaryConstant.SENSOR_TYPE_ELECTRIC_METER;
      } else if (this.activeName == 'water') {
        sensorType = dictionaryConstant.SENSOR_TYPE_WATER_METER;
      }
      const res = await selectUsageLineChartData({
        sensorType: sensorType,
        dateType: date || '近三十天',
      }).then();
      this.energyConsumptionData = res.data;
      // console.log(res.data);

      if (this.activeName == 'electric') {
        this.$nextTick(() => {
          this.createElectricLineChart();
        });
      } else if (this.activeName == 'water') {
        this.$nextTick(() => {
          this.createWaterLineChart();
        });
      }
    },
    // 获取七天缴费数据
    async getSelectLatestSevenDaysPayInfo() {
      const res = await selectLatestSevenDaysPayInfo().then();
      this.sevenDaysPayData = res.data;
      this.createPayBarChart();
    },
    async getSelectAlarmData() {
      const res = await selectAlarmData().then();
      this.arrearsAlarmData = res.data.arrearsAlarmData;
      this.dataAlarmData = res.data.dataAlarmData;
    },
    resizeChart() {
      this.electricMeterChart ? this.electricMeterChart.resize() : '';
      this.waterMeterChart ? this.waterMeterChart.resize() : '';
      this.electricMeterDashChart ? this.electricMeterDashChart.resize() : '';
      this.waterMeterDashChart ? this.waterMeterDashChart.resize() : '';
      this.electricMeterDashChart1 ? this.electricMeterDashChart1.resize() : '';
      this.waterMeterDashChart1 ? this.waterMeterDashChart1.resize() : '';
      this.electricLineChart ? this.electricLineChart.resize() : '';
      this.waterLineChart ? this.waterLineChart.resize() : '';
      this.payBarChart ? this.payBarChart.resize() : '';
    },
    createElectricMeterChart() {
      var chartDom = document.getElementById('electricMeter');
      this.electricMeterChart = echarts.init(chartDom);
      var option = {
        title: {
          text: '电表状态',
          left: 'left',
        },
        color: ['#99CCCC', '#3399CC'],
        tooltip: {
          trigger: 'item',
        },
        legend: {
          orient: 'vertical',
          x: 'right',
          y: 'bottom',
        },
        series: [
          {
            name: '电表',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['40%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '25',
                fontWeight: 'bold',
              },
            },
            labelLine: {
              show: false,
            },
            // data: [
            //   { value: 1048, name: '在线' },
            //   { value: 735, name: '离线' },
            // ],
            data: this.meterStatePieChartData,
          },
        ],
      };

      option && this.electricMeterChart.setOption(option);
      this.electricMeterChart.resize();
    },
    createWaterMeterChart() {
      var chartDom = document.getElementById('waterMeter');
      this.waterMeterChart = echarts.init(chartDom);
      var option = {
        title: {
          text: '水表状态',
          left: 'left',
        },
        color: ['#eecb5f', '#e3935d'],
        tooltip: {
          trigger: 'item',
        },
        legend: {
          orient: 'vertical',
          x: 'right',
          y: 'bottom',
        },
        series: [
          {
            name: '水表',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['40%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '25',
                fontWeight: 'bold',
              },
            },
            labelLine: {
              show: false,
            },
            // data: [
            //   { value: 566, name: '在线' },
            //   { value: 165, name: '离线' },
            // ],
            data: this.waterStatePieChartData,
          },
        ],
      };

      option && this.waterMeterChart.setOption(option);
      this.waterMeterChart.resize();
    },
    createElectricMeterDashChart() {
      var chartDom = document.getElementById('electric_meter_dash');
      this.electricMeterDashChart = echarts.init(chartDom);
      var option = {
        tooltip: {
          formatter: '{b} : {c}',
            transitionDuration: 0
        },
        series: [
          {
            type: 'gauge',
            min: 0,
            max: this.compareData.meterMaxValue,
            splitNumber: 2,
            radius: '80%',
            center: ['50%', '60%'],
            axisLine: {
              lineStyle: {
                color: [[1, '#ccc']],
                width: 3,
              },
            },
            splitLine: {
              show: false,
              distance: -18,
              length: 18,
              lineStyle: {
                color: '#f00',
              },
            },
            axisTick: {
              show: false,
              distance: -12,
              length: 10,
              lineStyle: {
                color: '#f00',
              },
            },
            axisLabel: {
              show: true,
              distance: -35,
              color: '#ccc',
              fontSize: 14,
            },
            anchor: {
              show: true,
              size: 20,
              itemStyle: {
                borderColor: '#000',
                borderWidth: 2,
              },
            },
            pointer: {
              offsetCenter: [0, '5%'],
              length: '100%',
              itemStyle: {
                color: '#000',
              },
            },
            detail: {
              show: false,
              valueAnimation: true,
              precision: 1,
              offsetCenter: [0, '50%'],
            },
            title: {
              offsetCenter: [0, '-50%'],
            },
            data: [
              {
                value: this.compareData.meterCurValue,
                name: '电表',
              },
            ],
          },
          {
            type: 'gauge',
            min: 0,
            max: 10000,
            center: ['50%', '60%'],
            splitNumber: 2,
            axisLine: {
              lineStyle: {
                color: [[1, '#61a5e8']],
                width: 8,
              },
            },
            splitLine: {
              distance: -3,
              length: 18,
              width: 15,
              lineStyle: {
                color: '#b0d2f4',
              },
            },
            axisTick: {
              distance: 0,
              length: 10,
              width: 5,
              lineStyle: {
                color: '#b0d2f4',
              },
            },
            axisLabel: {
              show: false,
              distance: 3,
              fontSize: 14,
              color: '#000',
            },
            pointer: {
              show: false,
            },
            title: {
              show: false,
            },
            anchor: {
              show: true,
              size: 14,
              itemStyle: {
                color: '#000',
              },
            },
            detail: {
              color: '#e16a5f',
              formatter: '{value} ' + '\n' + ' kW·h',
              fontSize: 13,
            },
            data: [
              {
                value: this.compareData.meterCurValue,
                name: '电表',
              },
            ],
          },
        ],
      };
      option && this.electricMeterDashChart.setOption(option);
      this.electricMeterDashChart.resize();
    },
    createWaterMeterDashChart() {
      var chartDom = document.getElementById('water_meter_dash');
      this.waterMeterDashChart = echarts.init(chartDom);
      var option = {
        tooltip: {
          formatter: '{b} : {c}',
            transitionDuration: 0
        },
        series: [
          {
            type: 'gauge',
            name: '水表',
            min: 0,
            max: this.compareData.waterMaxValue,
            center: ['50%', '60%'],
            splitNumber: 2,
            radius: '80%',
            axisLine: {
              lineStyle: {
                color: [[1, '#ccc']],
                width: 3,
              },
            },
            splitLine: {
              show: false,
              distance: -18,
              length: 18,
              lineStyle: {
                color: '#f00',
              },
            },
            axisTick: {
              show: false,
              distance: -12,
              length: 10,
              lineStyle: {
                color: '#f00',
              },
            },
            axisLabel: {
              show: true,
              distance: -35,
              color: '#ccc',
              fontSize: 14,
            },
            anchor: {
              show: true,
              size: 20,
              itemStyle: {
                borderColor: '#000',
                borderWidth: 2,
              },
            },
            pointer: {
              offsetCenter: [0, '5%'],
              length: '100%',
              itemStyle: {
                color: '#000',
              },
            },
            detail: {
              show: false,
              valueAnimation: true,
              precision: 1,
              offsetCenter: [0, '50%'],
            },
            title: {
              offsetCenter: [0, '-50%'],
            },
            data: [
              {
                value: this.compareData.waterCurValue,
                name: '水表',
              },
            ],
          },
          {
            type: 'gauge',
            min: 0,
            max: 10000,
            center: ['50%', '60%'],
            splitNumber: 2,
            axisLine: {
              lineStyle: {
                color: [[1, '#61a5e8']],
                width: 8,
              },
            },
            splitLine: {
              distance: -3,
              length: 18,
              width: 15,
              lineStyle: {
                color: '#b0d2f4',
              },
            },
            axisTick: {
              distance: 0,
              length: 10,
              width: 5,
              lineStyle: {
                color: '#b0d2f4',
              },
            },
            axisLabel: {
              show: false,
              distance: 3,
              fontSize: 14,
              color: '#000',
            },
            pointer: {
              show: false,
            },
            title: {
              show: false,
            },
            anchor: {
              show: true,
              size: 14,
              itemStyle: {
                color: '#000',
              },
            },
            detail: {
              color: '#e16a5f',
              fontSize: 13,
              formatter: '{value} ' + '\n' + ' m³',
            },
            data: [
              {
                value: this.compareData.waterCurValue,
                name: '水表',
              },
            ],
          },
        ],
      };

      option && this.waterMeterDashChart.setOption(option);
      this.waterMeterDashChart.resize();
    },
    createElectricLineChart() {
      var chartDom = document.getElementById('electric_lineChart');
      this.electricLineChart = echarts.init(chartDom);
      var option = {
        // color: ['#fe875b'],
        tooltip: {
          trigger: 'axis',
          transitionDuration: 0,
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        grid: {
          left: 80,
          right: 20,
          bottom: 20,
          top: 30,
        },
        xAxis: {
          type: 'category',
          data: this.energyConsumptionData.xData,
        },
        yAxis: {
          type: 'value',
          name: 'kW·h',
        },
        series: [
          {
            data: this.energyConsumptionData.yData,
            type: 'line',
            smooth: true,
          },
        ],
      };

      option && this.electricLineChart.setOption(option);
      this.electricLineChart.resize();
    },
    createWaterLineChart() {
      var chartDom = document.getElementById('water_lineChart');
      this.waterLineChart = echarts.init(chartDom);
      var option = {
        color: ['#67b580'],
        tooltip: {
          trigger: 'axis',
          transitionDuration: 0,
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        grid: {
          left: 80,
          right: 20,
          bottom: 20,
          top: 30,
        },
        xAxis: {
          type: 'category',
          data: this.energyConsumptionData.xData,
        },
        yAxis: {
          type: 'value',
          name: 'm³',
        },
        series: [
          {
            data: this.energyConsumptionData.yData,
            type: 'line',
            smooth: true,
          },
        ],
      };

      option && this.waterLineChart.setOption(option);
      this.waterLineChart.resize();
    },
    createPayBarChart() {
      var chartDom = document.getElementById('pay_barChart');
      this.payBarChart = echarts.init(chartDom);
      var option = {
        color: ['#7ecf51', '#61a5e8', '#e3935d'],
        tooltip: {
          trigger: 'axis',
          transitionDuration: 0,
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        grid: {
          left: 60,
          right:20,
          bottom: 30,
          top: 30,
        },
        legend: {
          data: ['电表', '水表', '合计'],
        },
        xAxis: [
          {
            type: 'category',
            data: this.sevenDaysPayData.xData,
            axisPointer: {
              type: 'shadow',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '元',
            axisLabel: {
              formatter: '{value} ',
            },
          },
          // {
          //   type: 'value',
          //   name: '元',
          //   axisLabel: {
          //     formatter: '{value} ',
          //   },
          // },
        ],
        series: [
          {
            name: '电表',
            type: 'bar',
            // data: [
            //   2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4,
            //   3.3,
            // ],
            data: this.sevenDaysPayData.yData1,
          },
          {
            name: '水表',
            type: 'bar',
            // data: [
            //   2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0,
            //   2.3,
            // ],
            data: this.sevenDaysPayData.yData2,
          },
          {
            name: '合计',
            type: 'line',
            smooth: true,
            // yAxisIndex: 1,
            // data: [
            //   2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2,
            // ],
            data: this.sevenDaysPayData.yData3,
          },
        ],
      };

      option && this.payBarChart.setOption(option);
      this.payBarChart.resize();
    },
  },
  beforeDestroy() {
    clearInterval(this.timeInterval);
    this.websocket.onclose = this.closeWebsocket;
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 98%;
  padding: 0 15px;
  box-sizing: border-box;
}
.box_shadow {
  box-shadow: 3px 3px 6px 3px #ccc;
}
.white {
  background-color: #fff;
}
.box_title {
  padding-bottom: 12px;
  font-size: 14px;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
}
/deep/ .el-tabs__header {
  margin-bottom: 5px !important;
}
.pieChart {
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 1370px) {
  .first_row {
    .second_grid {
      padding: 10px !important;
      .compare_data {
        p {
          font-size: 0.8rem !important;
        }
        .iconfont::before {
          margin-left: 10px !important;
          font-size: 0.9rem !important;
        }
      }
    }
    .third_grid {
      padding: 0 10px 10px !important;
    }
  }
  .second_row {
    .first_grid {
      padding: 0 10px 10px !important;
    }
    .second_grid {
      padding: 10px !important;
    }
  }
}
.first_row {
  height: 50%;
  width: 100%;
  display: flex;
  margin-bottom: 1%;
  padding-top: 3px;
  .first_grid {
    width: 30%;
    height: 100%;
    // background-color: rgb(148, 197, 193);
    @media screen and (max-width: 1370px) {
      .shop_general {
        padding: 10px !important;
      }
      .icon {
        width: 2rem !important;
        height: 2rem !important;
        line-height: 2rem !important;
      }
      .iconfont::before {
        font-size: 1.2rem !important;
      }
      .num {
        font-size: 1.3rem;
      }
    }
    .shop_general {
      width: 100%;
      height: 35%;
      box-sizing: border-box;
      padding: 15px 20px;
      .box_content {
        height: 70%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .item {
          display: flex;
          width: 33%;
          height: 100%;
          justify-content: space-around;
          // margin-top: 1rem;
          align-items: center;
          .icon {
            width: 3rem;
            height: 3rem;
            line-height: 3rem;
            border-radius: 50%;
            margin-right: 10px;
            color: white;
            text-align: center;
            font-size: 2rem;
            box-shadow: 5px 3px 5px 2px rgb(219, 218, 218);
          }
          .iconfont::before {
            font-size: 1.8rem !important;
          }
          .bg1 {
            background-color: #2db7f5;
          }
          .bg2 {
            background-color: #7d88c2;
          }
          .bg3 {
            background-color: #7bc655;
          }
          .title {
            font-size: 0.8rem;
            color: #666;
          }
          .num {
            font-size: 1.5rem;
            color: #444;
            text-align: center;
            font-weight: bold;
          }
        }
      }
    }
    .status {
      width: 100%;
      height: 63%;
      display: flex;
      margin-top: 1.5%;
      .electric_meter,
      .water_meter {
        width: 49%;
        height: 100%;
        padding: 10px;
      }
      .water_meter {
        margin-left: 2%;
      }
    }
  }
  .second_grid {
    width: 29%;
    height: 100%;
    margin: 0 1%;
    padding: 15px 20px;
    .btns {
      width: 100%;
      text-align: right;
      margin-top: 5px;
      span {
        display: inline-block;
        padding: 3px 10px;
        border-radius: 5px;
        margin-left: 5px;
        cursor: pointer;
      }
    }
    .box_content {
      // padding: 10px 0;
      height: calc(100% - 60px) !important;
      display: flex;

      .dashChart {
        width: 100%;
        height: 100%;
      }
      .left,
      .right {
        width: 50%;
        height: 75%;
      }
      .compare_data {
        p {
          margin: 8px 0;
          .compare_tit {
            font-weight: bold;
            color: #666;
            font-size: 0.8rem;
          }
          .numStyle {
            flex: 1;
            color: #07a9f0;
            font-weight: bold;
            font-size: 0.8rem !important;
          }
          .iconfont {
            font-size: 0.8rem !important;
            display: inline-block;
            width: 70px;
            text-align: left;
          }
          .iconfont::before {
            margin-left: 10px;
            font-size: 0.8rem !important;
          }
          .rateSpanRed {
            color: #ec808d;
          }
          .rateSpanGreen {
            color: #caf982;
          }
        }
      }
    }
  }
  .third_grid {
    width: 39%;
    height: 100%;
    padding: 10px 20px;
    overflow: hidden;
    /deep/ .el-tabs__content {
      overflow: hidden !important;
      height: 90% !important;
      padding-top: 0;
    }
    .el-tab-pane {
      height: 99%;
    }
    /deep/ .dv-scroll-board {
      color: #333;
      width: 100%;
      height: 100%;
      .ceil {
        padding: 0 6px !important;
      }
      .row-item {
        border-bottom: 1px solid #eee;
        text-align: center;
      }
      .header {
        text-align: center;
      }
      .rows {
        border-bottom: 1px solid #eee;
      }
    }
    .titleRow {
      display: flex;
      border-bottom: 1px solid #ddd;
      li {
        width: 100%;
        flex: 1;
        display: flex;
        line-height: 42px;
        span {
          flex: 1;
          text-align: center;
          font-size: 13px;
          color: rgb(24, 23, 23);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .seamless-warp {
      height: 50%;
      overflow: hidden;
      .item li {
        height: 40px;
        display: flex;
        padding: 0 10px;
        border-bottom: 1px solid #ddd;
        span {
          flex: 1;
          text-align: center;
          line-height: 40px;
          font-size: 13px;
          color: rgb(24, 23, 23);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
.second_row {
  height: 48%;
  width: 100%;
  display: flex;

  .first_grid {
    width: 60%;
    height: 100%;
    padding: 15px;
    .header {
      height: 34px;
      div {
        float: right;
        margin-top: 10px;
        margin-right: 20px;
        span {
          padding: 3px 10px;
          border: 1px solid #ddd;
          border-radius: 3px;
          margin: 0 5px;
          cursor: pointer;
        }
      }
    }
    /deep/ .el-tabs__content {
      padding-top: 0;
    }

    .el-tab-pane {
      height: 100%;
    }
    .content {
      height: calc(100% - 40px) !important;
    }
  }
  .lineChart {
    width: 98%;
    height: 98%;
  }
  .second_grid {
    width: 39%;
    height: 100%;
    margin-left: 1%;
    padding: 15px;
    .header {
      height: 40px;
      .tit {
        font-size: 14px;
        font-weight: bold;
        color: #333;
      }
    }
    .content {
      height: calc(100% - 40px);
    }
  }
}
</style>
